<mat-tab-group
  #tabGroup
  onsip-tab-group-custom-width
  onsip-tab-group-primary
  onsip-no-chevron-tab-group
  (selectedTabChange)="changeSelectedPrev($event)"
>
  <mat-tab>
    <ng-template mat-tab-label>
      {{ "ONSIP_I18N.WEB" | translate }}
    </ng-template>
    <ng-container *ngTemplateOutlet="web"></ng-container>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      {{ "ONSIP_I18N.MOBILE" | translate }}
    </ng-template>
    <ng-container *ngTemplateOutlet="mobile"></ng-container>
  </mat-tab>
</mat-tab-group>

<ng-template #web>
  @if (showFullWeb | async) {
  <onsip-full-web-preview-frame
    #saysoPreviewWeb
    [buttonColor]="(buttonColor | async)!"
    [buttonLocation]="(buttonLocation | async)!"
    [gradientOverlay]="(gradientOverlay | async)!"
    [width]="browserWidth"
    [removedOnsipBranding]="(removedOnsipBranding | async)!"
  >
    <onsip-web-topics-list-preview
      [accentColor]="(accentColor | async)!"
      [topics]="(previewTopics | async)!"
    >
    </onsip-web-topics-list-preview>
  </onsip-full-web-preview-frame>
  } @else {
  <onsip-small-web-preview-frame
    #saysoPreviewWeb
    [buttonColor]="(buttonColor | async)!"
    [buttonLocation]="(buttonLocation | async)!"
    [gradientOverlay]="(gradientOverlay | async)!"
    [removedOnsipBranding]="(removedOnsipBranding | async)!"
  >
    <onsip-web-topics-list-preview
      [accentColor]="(accentColor | async)!"
      [topics]="(previewTopics | async)!"
    >
    </onsip-web-topics-list-preview>
  </onsip-small-web-preview-frame>
  }
</ng-template>

<ng-template #mobile>
  <onsip-mobile-preview-frame
    #saysoPreviewMobile
    [buttonColor]="(buttonColor | async)!"
    [buttonLocation]="(buttonLocation | async)!"
    [gradientOverlay]="(gradientOverlay | async)!"
    [width]="(mobileWidth | async)!"
    [removedOnsipBranding]="(removedOnsipBranding | async)!"
  >
    <onsip-mobile-topics-list-preview
      [accentColor]="(accentColor | async)!"
      [topics]="(previewTopics | async)!"
    >
    </onsip-mobile-topics-list-preview>
  </onsip-mobile-preview-frame>
</ng-template>
